(function () {
  'use strict';

  angular
    .module('ecapp')
    /**
     * ???
     *
     * @ngdoc directive
     * @name btEventModalSpeechTranscript
     * @memberOf ecapp
     */
    .directive('btEventModalSpeechTranscript', [
      '$templateCache',
      function ($templateCache) {
        return {
          restrict: 'E',
          template: $templateCache.get('directives/event-modal/speech/transcript.html'),
        };
      },
    ]);
})();
